import React, { useState } from 'react';
import { Box, TextField, Button, InputAdornment } from '@mui/material';
import { Search as SearchIcon, Add as AddIcon } from '@mui/icons-material';

type SearchBarProps = {
  onSearch: (term: string) => void;
  onCreate?: () => void;
};

const BeneficiarySearchBar: React.FC<SearchBarProps> = ({ onSearch, onCreate }) => {
  const [searchValue, setSearchValue] = useState<string>('');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        gap: 2,
      }}
    >
      <TextField
        placeholder="Buscar por nome, documento, etc."
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSearch(searchValue);
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" onClick={() => onSearch(searchValue)} sx={{ cursor: 'pointer' }}>
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        sx={{
          flexGrow: 1,
          maxWidth: '40vw',
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            borderRadius: 0,
            '& fieldset': {
              border: 'none',
            },
            borderBottom: '1px solid #ccc',
            '&:hover': {
              borderBottom: '1px solid #999',
            },
            '&.Mui-focused': {
              borderBottom: '2px solid #1976d2',
            },
          },
        }}
      />

      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onCreate}
        sx={{
          textTransform: 'none',
          fontWeight: 500,
          px: 3,
          py: 1.5,
          whiteSpace: 'nowrap',
        }}
      >
        Cadastrar
      </Button>
    </Box>
  );
};

export default BeneficiarySearchBar;
